import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/xinwen/list",
      method: "get",
      params: query
    });
  },
  // 删除
  remove(data) {
    return request({
      url: "/xinwen/remove",
      method: "post",
      data
    });
  },
};
export default index;